module.exports = __webpack_public_path__ + "img/hos.fa992ede.png";